import { Link, useTranslation } from 'gatsby-plugin-react-i18next';
import React, { useEffect } from 'react';
import { useAuth0 } from '../../../services/auth0/useAuth0';
import { useTranslationInternal } from '../../../services/helpers';
import { Header, StyledText } from './styled';

export const HeaderTitle = ({ type }) => {
  const t = useTranslationInternal()

  return (
    <Header className="has-text-left title" style={{ marginBottom: 24 }}>
      {type === "register" ? t('auth.register') : t('auth.login')}
    </Header>
  )
}

export const Footer = ({ type }) => {
  const t = useTranslationInternal()
  if (type === "resetPassword") {
    return (
      <Link to="/app/login" className="is-flex is-flex-direction-row "
        style={{ color: '#1E222D', marginTop: 30, alignItems: 'center', justifyContent: 'center', fontSize: 13, }}>
        <StyledText>{t('forgotPassword.goToLoginPage')}</StyledText>
      </Link>
    )
  }
  if (type === "register") {
    return (
      <Link to="/app/login" className="is-flex is-flex-direction-row "
        style={{ color: '#1E222D', marginTop: 30, alignItems: 'center', justifyContent: 'center', fontSize: 13, }}>
        <span>{t('auth.doYouHaveAccount')}&nbsp;</span>
        <StyledText>{t('auth.login')}</StyledText>
      </Link>
    )
  }
  return (
    <Link to="/app/register" className="is-flex is-flex-direction-row " style={{ color: '#1E222D', marginTop: 30, alignItems: 'center', justifyContent: 'center', fontSize: 13, }}>
      <span>{t('auth.dontYouHaveAccount')}&nbsp;</span>
      <StyledText>{t('auth.register')}</StyledText>
    </Link>
  )
}

export const ForgotPasswordLink = ({ type }) => {
  const t = useTranslationInternal()

  if (type === "login") {
    return (
      <Link to="/app/forgot-password" className="is-flex is-flex-direction-row " style={{ fontSize: 13, color: '#1E222D', marginTop: -8, marginBottom: 24 }}>
        <StyledText>{t('auth.forgotPassword')}</StyledText>
      </Link>
    )
  }

  return null
}